import { createWebHashHistory, createWebHistory } from 'vue-router'

export const isShortGiftPath = value => typeof value === 'string' && /^\/g\/[A-Za-z][A-Za-z0-9]{7}$/.test(value)

// Only the public gift entrance owns a clean path. Other platform pages retain
// their existing hash URLs, including refreshable login/onboarding pages.
export function createEntryHistory(pathname) {
  return isShortGiftPath(pathname) ? createWebHistory('/') : createWebHashHistory()
}

export function giftHistoryNavigationTarget(pathMode, to) {
  if (pathMode && to.name !== 'SubscriptionGiftShortClaim') return `/#${to.fullPath}`
  if (!pathMode && to.name === 'SubscriptionGiftShortClaim') return to.fullPath
  return null
}
